import React from 'react';

import { TooltipWrapper } from '../../display/TooltipWrapper';
import type { TooltipPosition } from '../Tooltip';

import { Avatar } from './Avatar';
import type { Props as AvatarProps } from './Avatar';

type Props = AvatarProps & {
  position?: TooltipPosition;
};

export const AvatarWithTooltip = ({ position, ...props }: Props) => {
  const [first = '', ...rest] = props.name.split(/\s+/);
  const last = rest.pop() || '';
  const lastInitial = last ? `${last.slice(0, 1)}.` : '';
  const tooltipName = `${first} ${lastInitial}`.trim();
  return (
    <TooltipWrapper content={tooltipName} position={position}>
      {({ childProps }) => <Avatar {...childProps} {...props} isBlock={true} />}
    </TooltipWrapper>
  );
};
